import * as Yup from 'yup';

import { type FieldSchema, type ValidatorContext } from '../types';

const createMultiSelectValidator = (context: ValidatorContext): FieldSchema => {
  const { l, isRequired, requiredMessage } = context;

  let validator = Yup.array().ensure().nullable();

  if (isRequired) {
    const message = requiredMessage ?? l('Select at least one option');

    validator = validator.min(1, message).required(message);
  }

  return validator;
};

export default createMultiSelectValidator;
